import { render, staticRenderFns } from "./StudentFileUploadDetail.vue?vue&type=template&id=5f0b29a0&scoped=true&"
import script from "./StudentFileUploadDetail.vue?vue&type=script&lang=ts&"
export * from "./StudentFileUploadDetail.vue?vue&type=script&lang=ts&"
import style0 from "./StudentFileUploadDetail.vue?vue&type=style&index=0&id=5f0b29a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0b29a0",
  null
  
)

export default component.exports